export default {
  logo: {
    marginBottom: 10,
    maxWidth: '100%',
    maxHeight: 80
  },
  projectTeamTableContainer: {
    overflowX: 'auto'
  },
  marginButtonRight: {
    position: 'relative',
    float: 'right'
  },
  marginButtonContainerRight: {
    float: 'right',
    padding: '8px'
  },
  marginButtonLeft: {
    position: 'relative',
    float: 'left'
  },
  marginButtonContainerLeft: {
    float: 'left',
    padding: '8px'
  },
  marginButtonContainerCenter: {
    textAlign: 'center'
  },
  removeDialogText: {
    paddingTop: '10px',
    textAlign: 'center',
    color: 'black'
  },
  removeDialogPaper: {
    width: '225px',
    height: '88px',
    backgroundColor: '#e8e8e8'
  },
  flexGrid: {
    display: 'flex',
    padding: 8
  },
  flex: {
    flex: 1,
    marginRight: 25
  }
};



// WEBPACK FOOTER //
// ./src/views/ViewCustomerCase/ViewCustomerCase.css.js